module.exports = __webpack_public_path__ + "img/cart-reminder-yt-cover-sms.d74148ca.png";